import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const CompactDotsIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 15 4"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 4)}
      {...svgProps}
      stroke={svgProps.stroke ?? "none"}
      fill={color ?? svgProps.fill ?? "currentColor"}
    >
      <path d="M2 3.8c1 0 1.7-.7 1.7-1.6C3.7 1.3 3 .6 2.1.6 1 .6.5 1.3.5 2.2c0 1 .7 1.6 1.6 1.6ZM12.5 3.8c.9 0 1.6-.7 1.6-1.6 0-.9-.7-1.6-1.6-1.6-1 0-1.6.7-1.6 1.6 0 1 .7 1.6 1.6 1.6ZM7.3 3.8c.9 0 1.6-.7 1.6-1.6C9 1.3 8.2.6 7.3.6c-1 0-1.6.7-1.6 1.6 0 1 .7 1.6 1.6 1.6Z" />
    </SVG>
  );
};
